import Vue from 'vue'
import Router from 'vue-router'
import cognito from '@/cognito'
import Login from '@/components/Login'

Vue.use(Router)

const logout = (to, form, next) => {
  cognito.logout()
  location.href = '/post_logout'
}

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/',
      redirect: '/login',
    },
    {
      path: '/logout',
      name: 'logout',
      beforeEnter: logout
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js